var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:tag-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.25 7.5C27.4926 7.5 28.5 8.50736 28.5 9.75C28.5 10.9926 27.4926 12 26.25 12C25.0074 12 24 10.9926 24 9.75C24 8.50736 25.0074 7.5 26.25 7.5Z",
    stroke: "#038CEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4998 21.0002L14.9998 25.5002M4.16083 16.7162C2.65633 18.3962 2.62483 20.9312 4.00483 22.7162C6.68534 26.1959 9.80416 29.3147 13.2838 31.9952C15.0688 33.3752 17.6038 33.3437 19.2838 31.8392C23.8252 27.777 28.0925 23.4184 32.0578 18.7922C32.4582 18.3321 32.7047 17.7583 32.7628 17.1512C33.0088 14.4572 33.5173 6.69621 31.4098 4.59021C29.3023 2.48421 21.5428 2.99121 18.8488 3.23871C18.2417 3.29688 17.668 3.54338 17.2078 3.94371C12.5816 7.90853 8.22311 12.1754 4.16083 16.7162Z",
    stroke: "#038CEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.8d35182a522e5fad2af02be6fc2a7dfe.svg";
export { ForwardRef as ReactComponent };